

import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_223_0_SidePanelFooter";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_223_0_SidePanelFooter__root","footerContainer":"wds_1_223_0_SidePanelFooter__footerContainer","divider":"wds_1_223_0_SidePanelFooter__divider"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-side-panel-footer-padding-vertical":"--wds-side-panel-footer-padding-vertical","wds-side-panel-footer-padding-horizontal":"--wds-side-panel-footer-padding-horizontal","wds-side-panel-footer-divider-height":"--wds-side-panel-footer-divider-height"}; 




